var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 71,
    viewBox: "0 0 86 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 34.7005C2.69531 36.2489 2.87699 37.687 3.07515 39.2157C3.28996 40.8728 3.24669 42.601 3.24669 44.27C3.24669 47.3887 3.2899 50.5189 3.13029 53.6312C2.87518 58.6059 2.80559 63.5684 2.80559 68.5553",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14258 26.9812C2.14258 27.1771 2.17321 27.263 2.25285 27.4223",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1302 13.2054C83.3615 9.53282 82.1319 6.39815 79.4691 3.88332C77.2059 1.74584 74.7132 1.5528 71.7493 1.5528C67.7651 1.5528 64.8924 5.68094 64.3046 9.20791C63.114 16.3511 61.9902 23.4463 61.9902 30.6843C61.9902 34.9071 62.2815 39.1039 62.2815 43.2756C62.2815 45.1677 62.8642 47.1035 62.8642 48.9724C62.8642 50.2412 62.7879 52.6985 63.3012 53.8277C63.7232 54.7562 63.7381 56.7416 63.7381 57.7766C63.7381 59.039 63.7381 60.3013 63.7381 61.5637C63.7381 63.8942 63.7381 66.2248 63.7381 68.5553",
    stroke: "#1023DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2988 34.7627C58.4785 34.7627 68.8111 35.054 78.8869 35.054",
    stroke: "#1023DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIf);
export default __webpack_public_path__ + "static/media/IF.89f7b97fb0c22a3a43bd7ee98357ccc1.svg";
export { ForwardRef as ReactComponent };